import styled from '@emotion/styled';
import Card from 'storybookConfig/stories/cells/Card';
import Heading from 'storybookConfig/stories/molecules/Heading';
import Body from 'storybookConfig/stories/molecules/Body';
import IconTile from 'storybookConfig/stories/molecules/IconTile';
import type { IconName } from 'storybookConfig/mixins/icons';

const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
`;

const Title = styled(Heading)`
  text-align: center;
  margin-bottom: 8px;
`;

const Subtitle = styled(Body)`
  text-align: center;
  color: ${({ theme }) => theme.color.bodyTextSecondary};
  margin-bottom: 24px;
`;

const ContentWrapper = styled.div`
  padding: 0 120px;
  text-align: center;
`;

interface ReturnPolicyPanelProps {
  /** The Lucide icon above the title, in an `IconTile`. */
  iconName: IconName;
}

const ReturnPolicyPanel = ({ iconName }: ReturnPolicyPanelProps) => (
  <Card>
    <ContentWrapper>
      <IconContainer>
        <IconTile name={iconName} />
      </IconContainer>
      <Title variant="Headings/H3">Return Policy</Title>
      <Subtitle>Link to your return policy for potential retail partners to reference.</Subtitle>
    </ContentWrapper>
  </Card>
);

export default ReturnPolicyPanel;
